import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { Col, Divider, Form, FormInstance, Row, Select } from 'antd';
import SectionCard from '../../SectionCard';
import SelectInvoiceCST from '../SelectInvoiceCST';
import SelectInvoiceClassificationTax from '../SelectInvoiceClassificationTax';
import CbsFormFields from '../CbsFormFields';
import IbsFormFields from '../IbsFormFields';
import PresumedCreditIbsCbsFormFields from '../PresumedCreditIbsCbsFormFields';
import IbsZfmPresumedCreditFormFields from '../IbsZfmPresumedCreditFormFields';
import RegularTaxationFormFields from '../RegularTaxationFormFields';
import GovernmentProcurementFormFields from '../GovernmentProcurementFormFields';
import SinglePhaseFormFields from '../SinglePhaseFormFields';
import CompetencyAdjustmentFormFields from '../CompetencyAdjustmentFormFields';
import CreditTransfersReversalFormFields from '../CreditTransfersReversalFormFields';

interface Props {
  form: FormInstance;
  disabledFields: boolean;
  prefixPath?: string[];
  invoiceType?: InvoiceType;
}

export default function IbsCbsFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
  ...props
}: Props) {
  const ibsCbsCst = Form.useWatch([...prefixPath, 'ibsCbsCst'], props.form);

  return (
    <Form form={props.form} disabled={props.disabledFields}>
      <h1>IBS / CBS - Identificação principal</h1>

      {/* ===== IBS / CBS - Identificação principal UB12..UB16 ===== */}
      <SectionCard
        visible
        style={{ marginBottom: 24 }}
        title="Identificação do Regime"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <FloatingFormItem
              name={[...prefixPath, 'ibsCbsCst']}
              label="CST"
              getValueFromEvent={(value) => {
                props.form.setFieldValue(
                  [...prefixPath, 'ibsCbsTaxClassification'],
                  undefined,
                );
                return value;
              }}
              // rules={[requiredField]}
            >
              <SelectInvoiceCST
                disabled={props.disabledFields}
                queryParams={{ cstType: 'IBS_CBS' }}
                allowClear
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12}>
            <FloatingFormItem
              name={[...prefixPath, 'ibsCbsTaxClassification']}
              label="Classificação Tributária"
              // rules={[requiredField]}
            >
              <SelectInvoiceClassificationTax
                queryParams={{
                  classificationType: 'IBS_CBS',
                  cstCode: ibsCbsCst,
                }}
                disabled={props.disabledFields}
                allowClear
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              name={[...prefixPath, 'ibsCbsDonation']}
              label="Indicação de Doação"
            >
              <Select
                options={[
                  { value: '0', label: '0 - Normal' },
                  { value: '1', label: '1 - Doação' },
                ]}
                disabled={props.disabledFields}
                allowClear
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              name={[...prefixPath, 'ibsCbsBaseCalculation']}
              label="Base de Cálculo"
              // rules={[requiredField]}
            >
              <InputDecimal disabled={props.disabledFields} />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>

      <IbsFormFields prefixPath={prefixPath} />

      <Divider />

      <CbsFormFields prefixPath={prefixPath} invoiceType={props.invoiceType} />

      <Divider />

      <PresumedCreditIbsCbsFormFields prefixPath={prefixPath} />

      <Divider />

      <IbsZfmPresumedCreditFormFields prefixPath={prefixPath} />

      <Divider />

      <RegularTaxationFormFields prefixPath={prefixPath} />

      <Divider />

      <GovernmentProcurementFormFields prefixPath={prefixPath} />

      <Divider />

      <SinglePhaseFormFields prefixPath={prefixPath} />

      <Divider />

      <CompetencyAdjustmentFormFields prefixPath={prefixPath} />

      <Divider />

      <CreditTransfersReversalFormFields prefixPath={prefixPath} />
    </Form>
  );
}
